import * as apiDelete from 'api/activity/DeleteActivityIdV1';
import * as apiRestore from 'api/activity/PostActivityRestoreV1';
import * as apiPostSearch from 'api/activity/PostActivitySearchV1';

export default class Activity {
	public id: string = '';
	public name: string = '';
	public sortOrder: number = 0;

	public constructor(input?: apiPostSearch.ResponseActivity) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseActivity) {
		this.id = input.id;
		this.name = input.name;
		this.sortOrder = input.sortOrder;
	}
}
